<template>
  <v-layout row wrap justify-center>
    <v-flex xs12 sm10 md6>
      <v-card class="elevation-12 pa-5">
        <v-alert type="error" :value="requestUnsuccessful">
          <p>There was an error while processing your request. Try again.</p>
        </v-alert>
        <v-alert type="info" :value="requestReceived">
          <p>
            Topup request received, check your phone and enter your Mpesa pin
          </p>
        </v-alert>
        <v-text-field
          v-if="!requestReceived"
          label="Phone Number"
          placeholder="Mpesa phone number"
          v-model="phoneNumber"
          :error-messages="phoneNumberErrors"
          required
          mask="##########"
          prepend-icon="phone"
        >
        </v-text-field>
        <v-text-field
          v-if="!requestReceived"
          label="Amount"
          v-model="amount"
          :error-messages="amountErrors"
          required
          mask="##########"
          prepend-icon="money"
        >
        </v-text-field>
        <v-btn
          v-if="!requestReceived"
          class="ma-2"
          :loading="loading"
          :disabled="loading"
          color="primary"
          @click="topUp()"
        >
          Top Up with Mpesa
        </v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'TopUp',
  data() {
    return {
      phoneNumber: '',
      amount: '',
      loading: false,
      requestUnsuccessful: false,
      requestReceived: false
    }
  },
  validations() {
    return {
      phoneNumber: {
        required,
        minLength: minLength(10)
      },
      amount: {
        required
      }
    }
  },
  computed: {
    phoneNumberErrors() {
      const errors = []
      if (!this.$v.phoneNumber.$dirty) return errors
      !this.$v.phoneNumber.required && errors.push('Enter a valid phone number')
      !this.$v.phoneNumber.minLength &&
        errors.push('Enter a valid phone number')
      return errors
    },
    amountErrors() {
      const errors = []
      if (!this.$v.amount.$dirty) return errors
      !this.$v.amount.required && errors.push('Enter amount')
      return errors
    }
  },
  methods: {
    topUp() {
      this.$v.$touch()
      if (this.$v.$invalid) {
      } else {
        this.loading = true
        var bodyFormData = new FormData()
        bodyFormData.append('externalref', this.$auth.user().client.id)
        bodyFormData.append('amount', this.amount)
        bodyFormData.append('api_key', '8d29430ba38327d91303a935520e7b95')
        bodyFormData.append('phone_no', this.$app.formatPhone(this.phoneNumber))
        this.axios({
          method: 'post',
          url: 'https://stkpush.cube-messenger.com/stkpush.php',
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then(response => {
            // handle success
            this.loading = false
            this.$router.push({ name: 'accounts', params: { fromTopUp: true } })
          })
          .catch(error => {
            // handle error
            this.loading = false
            this.$app.log(error.message)
          })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/TopUp.vue